import {
  List,
  EditButton,
  ShowButton,
  SimpleList,
  Datagrid,
  DateField,
  TopToolbar,
  CreateButton,
  FunctionField,
} from "react-admin";
import { EmptyList } from "server/components";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { settings } from "app";
import CloneCampaignButton from "../components/CloneCampaignButton";
import { PRELIMINARY, MOBILE_BREAKPOINT, CampaignSubTypes } from "utils/constants";
import { formatDateBg } from "../../../server/formatting/formatDateBg";
import permissions from "app/permissions";
import CampaignTypeField from "../components/Fileds/CampaignTypeField";
import NameBgField from "../components/Fileds/NameBgField";
import NameEnField from "../components/Fileds/NameEnField";
import { CampaignExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import SecuredComponent from "server/security/SecuredComponent";
import { MobileListRow } from "features/MobileListRow";

const ListCampaigns = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={CampaignExporter(PRELIMINARY)} />
      </TopToolbar>
    );
  };

  return (
    <List
      actions={<ListActions hasCreate={true} />}
      title="Предварителни кампании"
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[{ label: "Начало на регистрация", value: formatDateBg(record.registrationStart) }]}
              />
              <MobileListRow fields={[{ label: "Име на английски език", value: <NameEnField /> }]} />
              <MobileListRow fields={[{ label: "Край на регистрация", value: formatDateBg(record.registrationEnd) }]} />
              <MobileListRow
                fields={[{ label: "Тип", value: <CampaignTypeField subTypeId={CampaignSubTypes.Preliminary} /> }]}
              />
              <MobileListRow
                fields={[
                  {
                    value: (
                      <Typography
                        fontSize={14}
                        color={record?.isFinished ? "error" : theme => theme.palette.success.main}
                      >
                        {record?.isFinished ? "Приключена" : "Активна"}
                      </Typography>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => (
            <>
              <SecuredComponent permission={permissions.canUpdateCampaigns}>
                <CloneCampaignButton
                  label=""
                  campaignType={PRELIMINARY}
                />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canUpdateCampaigns}>
                <EditButton
                  label=""
                  disabled={record?.isFinished}
                />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewCampaigns}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.compactDatagridCells}
        >
          <NameBgField label="Име на български език" />
          <NameEnField label="Име на английски език" />
          <DateField
            source="registrationStart"
            label="Начало на регистрация"
            locales="bg-BG"
            showTime
            sortable={false}
          />
          <DateField
            source="registrationEnd"
            label="Край на регистрация"
            locales="bg-BG"
            showTime
            sortable={false}
          />

          <CampaignTypeField
            label="Тип"
            subTypeId={CampaignSubTypes.Preliminary}
          />
          <FunctionField
            label="Активност"
            render={record => (
              <Typography
                fontSize={14}
                color={record?.isFinished ? "error" : theme => theme.palette.success.main}
              >
                {record?.isFinished ? "Приключена" : "Активна"}
              </Typography>
            )}
          />
          {/* All row actions share one column; below xl they stack vertically. */}
          <FunctionField
            label="Действия"
            render={record => (
              <Box sx={settings.style.stackingActionButtons}>
                <SecuredComponent permission={permissions.canUpdateCampaigns}>
                  <CloneCampaignButton campaignType={PRELIMINARY} />
                </SecuredComponent>
                <SecuredComponent permission={permissions.canUpdateCampaigns}>
                  <EditButton disabled={record?.isFinished} />
                </SecuredComponent>
                <SecuredComponent permission={permissions.canPreviewCampaigns}>
                  <ShowButton />
                </SecuredComponent>
              </Box>
            )}
          />
        </Datagrid>
      )}
    </List>
  );
};
export default ListCampaigns;
